(function () {
    function initGsTimelineScrollAnimation() {
      const sections = document.querySelectorAll(
        ".gs-story-timeline-section"
      );

      if (!sections.length) {
        return;
      }

      const reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      sections.forEach(function (section) {
        if (section.dataset.gsTimelineReady === "true") {
          return;
        }

        section.dataset.gsTimelineReady = "true";

        const heading = section.querySelector(
          ".gs-story-timeline-heading"
        );

        const revealItems = Array.from(
          section.querySelectorAll(
            ".gs-story-timeline-image-card, .gs-story-timeline-text-card"
          )
        );

        if (reducedMotion) {
          if (heading) {
            heading.classList.add("is-visible");
          }

          revealItems.forEach(function (item) {
            item.classList.add("is-visible");
          });

          return;
        }

        section.classList.add("gs-timeline-animate-ready");

        if (!("IntersectionObserver" in window)) {
          if (heading) {
            heading.classList.add("is-visible");
          }

          revealItems.forEach(function (item) {
            item.classList.add("is-visible");
          });

          return;
        }

        const observer = new IntersectionObserver(
          function (entries, currentObserver) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                currentObserver.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.24,
            rootMargin: "0px 0px -12% 0px"
          }
        );

        if (heading) {
          observer.observe(heading);
        }

        revealItems.forEach(function (item) {
          observer.observe(item);
        });
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        initGsTimelineScrollAnimation
      );
    } else {
      initGsTimelineScrollAnimation();
    }

    document.addEventListener(
      "shopify:section:load",
      initGsTimelineScrollAnimation
    );
  })();
